import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { EventManager } from 'src/app/core';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../modal.component';

@Component({
  selector: 'input-note-popup',
  templateUrl: './input-note-popup.component.html',
  styleUrls: ['./input-note-popup.component.scss']
})
export class InputNotePopUpComponent extends ModalComponent  implements OnInit, OnDestroy {
  @Input() eventBroadcast: string = '';
  @Input() note: string = '';
  subscriptions?: Subscription[] = [];
  constructor(
    private modalRef : NzModalRef,
    public formBuilder: FormBuilder,
    public eventManager: EventManager
  ) {
    super(eventManager);
  }
  ngOnDestroy(): void {
    this.eventManager.destroys(this.subscriptions);
  }
  save() {
    this.cancel();
    this.eventManager.broadcast({
      name: this.eventBroadcast,
      content: {
        note: this.note
      }
    });
  }
  cancel() {
    this.modalRef.close();
  }
}
